import { Bookmark } from "@mui/icons-material";
import { Button, IconButton } from "~/common/mui";
import { t } from "i18next";
import type { MouseEventHandler } from "react";
import { useProductDetailsUrl } from "~/features/PackageRestriction/hooks/useProductDetailsUrl";
import { isProductPMA } from "~/domains/product/utils/productDescriptorUtils";
import type { ProductDescriptor } from "~/domains/product/types/ProductDescriptor";

import { InfoProductMessagePMA } from "~/features/productDetails/components/ProductSummary/InfoProductMessagePMA";
import { redirectToUrl } from "~/utils/url/urlUtils";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";

const AddToWishlistSmall = ({ onClick }: { onClick?: MouseEventHandler<HTMLButtonElement> }) => {
  return (
    <IconButton
      key={"wishlist"}
      onClick={onClick}
      color="secondary"
      variant="contained"
      data-test-id={"button-wishlist"}
    >
      <Bookmark />
    </IconButton>
  );
};

const AddToCart = ({
  onClick,
  disabled,
  productDescriptor,
}: {
  onClick: MouseEventHandler<HTMLButtonElement>;
  disabled: boolean;
  productDescriptor: ProductDescriptor;
}) => {
  const url = useProductDetailsUrl(productDescriptor.base);
  if (isProductPMA(productDescriptor)) {
    return <InfoProductMessagePMA short={true} onClick={() => redirectToUrl(url)} />;
  }

  return (
    <Button
      size={"medium"}
      fullWidth={true}
      startIcon={<ShoppingCartIcon sx={{ fontSize: { phone: 16, tablet: 20 } }} />}
      disabled={disabled}
      onClick={onClick}
      data-test-id={"button-addtocart"}
    >
      {t("addToCartPopup.add.submitBtn")}
    </Button>
  );
};

export const SrpButtons = {
  AddToWishlistSmall,
  AddToCart,
};
